import selectedAtteributes from "@/constants/selectedAttrubites";
import axiosRequest from "@/utils/axios-config";
import { getCookie } from "cookies-next";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import useSWRMutation from "swr/mutation";

const useTopCategoryTabs = ({ topCategoryTabs }) => {

  const router = useRouter()
  const [updateTopCategoryTabs, setUpdateTopCategoryTabs] = useState(topCategoryTabs)
  const [topCategoryTabsId, setTopCategoryTabsId] = useState('')
  const [isTopCategoryTabsLoading, setIsTopCategoryTabsLoading] = useState(false)
  const handshake = getCookie("handshake");

  useEffect(() => setUpdateTopCategoryTabs(topCategoryTabs), [router, topCategoryTabs])

  const postFetcher = async (_, { arg }) => {
    const config = {
      method: "get",
      url: `/search/products/facets/category/${arg?.id}?pageNo=0&pageSize=30&${selectedAtteributes}&sortBy=price&sortDir=DESC`,
      headers:{
        'Authorization':`Bearer ${handshake}`
      },
    };
    const { data } = await axiosRequest(config);
    return data;
  };

  const res = useSWRMutation(
    `topCategoryTabs-products-${topCategoryTabsId}`,
    postFetcher,
    {
      revalidateOnMount: 30 * 60 * 1000, // 30 minutes in milliseconds
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      populateCache: true,
    }
  );

  const handleSwitchTabs = async (id) => {
    setTopCategoryTabsId(id)
    setIsTopCategoryTabsLoading(true)
    let selectedObj = updateTopCategoryTabs?.find(item => item?.category_id == id)
    if (!selectedObj?.products?.length) {
      const result = await res?.trigger({ id });
      const products = result?.data?.products
      console.log('products in handleSwitchTabs', products)
      products?.length && products != undefined && setUpdateTopCategoryTabs(updateTopCategoryTabs?.map(item => {
        if (item?.category_id == id) {
          return {
            ...item,
            products
          }
        }
        return {
          ...item,
        }
      }))
    }
    setIsTopCategoryTabsLoading(false)
  }

  return {
    updateTopCategoryTabs,
    handleSwitchTabs,
    isTopCategoryTabsLoading
  };
};

export default useTopCategoryTabs;